import React, { FC, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ErrorMessage, FormikValues, useFormikContext } from "formik";
import {
  AutocompleteRenderGetTagProps,
  Box,
  Checkbox,
  Chip,
} from "@mui/material";

import DropdownWithOther from "./DropdownWithOther";
import InputField from "../../../../../common/Form/Input/InputField";
import FormDropdownField from "../../../../../common/Form/Dropdown/FormDropdownField";
import FormToggleButton from "../../../../../common/Form/ToggleButton/FormToggleButton";

import { useGetSubmissionDropdownListQuery } from "../../../../../../generated/graphql";

import {
  ALL_STUDY_PHASE,
  TYPES_OF_FUNDING,
  ALL_TYPE_OF_STUDY,
} from "../../../../../../constants";
import {
  CO_INVESTIGATOR,
  DEPARTMENT,
  FUND_TYPE,
  IS_FUNDED,
  IS_TERMS_ACCEPTED,
  PRINCIPAL_INVESTIGATOR,
  PROTOCOL_NUMBER,
  SPONSOR,
  STUDY_PHASE,
  TITLE,
  TYPE_OF_STUDY,
} from "../../../../../../constants/forms";
import config from "../../../../../../utils/config";

const StudyDetails: FC = (): JSX.Element => {
  const { values, setFieldValue } = useFormikContext<FormikValues>();

  const { id } = useParams();
  const { data: dropdownLists, loading, error } = useGetSubmissionDropdownListQuery({
    variables: {},
  });

  const checkboxInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue(e.target.name, e.target.checked);
  };

  const dropdownInputHandler = (fieldName: string, value: any) => {
    setFieldValue(fieldName, value);
  };

  const toggleHandler = (e: React.MouseEvent, newToggle: boolean) => {
    setFieldValue(IS_FUNDED, newToggle);
    if (newToggle) {
      setFieldValue(FUND_TYPE, "");
    }
  };

  return (
    <>
      <InputField
        label={"1.1  Protocol Number/Short Title"}
        name={PROTOCOL_NUMBER}
        placeholder={"Protocol number"}
        // disabled={!!id}
      />

      <InputField
        label={"1.2  Study Title"}
        name={TITLE}
        placeholder={"Study Title"}
        // disabled={!!id}
      />

      <DropdownWithOther
        options={[...(dropdownLists?.getSubmissionDropdownList.sponsor || []) , "Others"]}
        disabled={false}
        label="1.3  Sponsor"
        name={SPONSOR}
        placeholder={"Sponsor"}
        // disabled={!!id}
      />

      <DropdownWithOther
        options={[...(dropdownLists?.getSubmissionDropdownList.principalInvestigator || []),"Others"]}
        disabled={false}
        label="1.4  Principal Investigator"
        name={PRINCIPAL_INVESTIGATOR}
        placeholder={"Principal Investigator"}
        // disabled={!!id}
      />
      <DropdownWithOther
        options={[...(dropdownLists?.getSubmissionDropdownList.coInvestigator || []),"Others"]}
        disabled={false}
        label="1.5  Co Investigator"
        name={CO_INVESTIGATOR}
        placeholder={"Co Investigator"}
        // disabled={!!id}
      />
      <DropdownWithOther
        options={[...(dropdownLists?.getSubmissionDropdownList.department || []), "Others"]}
        disabled={false}
        label="1.6  Department"
        name={DEPARTMENT}
        placeholder={"Department"}
        // disabled={!!id}
      />

      <FormDropdownField
        label="1.7  Email "
        value={values.emails}
        name={"emails"}
        options={["user1@gmail.com", "user2@gmail.com"]}
        inputHandler={dropdownInputHandler}
        multiple
        renderTags={(
          value: readonly string[],
          getTagProps: AutocompleteRenderGetTagProps
        ) =>
          value.map((option: string, index: number) => (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        disabled={false}
      />

      <DropdownWithOther
        name={STUDY_PHASE}
        label={"1.8  Study Phase"}
        placeholder={"Study phase"}
        options={ALL_STUDY_PHASE}
        disabled={false}
      />

      <DropdownWithOther
        name={TYPE_OF_STUDY}
        label={"1.9  Type of Study"}
        placeholder={"Type of Study"}
        options={ALL_TYPE_OF_STUDY}
        disabled={false}
      />

      <Box className="mg-b-10">
        <label className="form-label mg-b-20 font-size-14 font-weight-medium">
          1.10 Is Funded?{" "}
        </label>
        <FormToggleButton name={IS_FUNDED} onChange={toggleHandler} />
      </Box>

      {values[IS_FUNDED] && (
        <DropdownWithOther
          label="Type of Funding"
          name={FUND_TYPE}
          placeholder={"Type of Funding"}
          options={TYPES_OF_FUNDING}
          disabled={false}
        />
      )}

      <Box className="mg-t-50">
        <Checkbox
          checked={values.isTermsAccepted}
          name={IS_TERMS_ACCEPTED}
          onChange={checkboxInputHandler}
          disabled={false}
        />
        <Link to={config.terms} target="_blank" rel="noreferrer" className="form-label font-size-14 font-weight-medium cursor-pointer text-danger">
          Terms and Conditions{" "}
        </Link>
        <ErrorMessage
          name={IS_TERMS_ACCEPTED}
          render={(msg) => {
            return (
              <div>
                {" "}
                <span className="text-danger font-size-sm">{msg}</span>
              </div>
            );
          }}
        />
      </Box>
    </>
  );
};

export default StudyDetails;
